import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';
import { Button } from '@iwoca/orion';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import messages from './TopUpPending.messages';
import styles from '../DashboardActions.module.css';
import dashboardCtaStyles from '../../../dashboardComponents/DashboardCTA/DashboardCTA.module.css';
import { connect } from 'react-redux';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { OPEN_MODAL } from '@iwModals/Modals.actions';
import { TopupPendingSVG } from '@svgComponents/TopupPendingSVG/TopupPendingSVG';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';

const mapStateToProps = (state: RootState) => {
    return {
        requestedCashAmount:
            state?.api?.application?.data?.requested_products?.[0]
                ?.requested_cash_amount,
        requestedAmount:
            state?.api?.application?.data?.requested_products?.[0]?.amount,
        stateKey:
            state.siteContext.impersonatingStateKey ||
            state.siteContext.state_key
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    openHelpModal: () => {
        tracking.ampli.topupChangeRequestCtaClicked();
        dispatch({
            type: OPEN_MODAL,
            id: 'HelpModal'
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type Props = PropsFromRedux & WrappedComponentProps;

const TopUpPending = ({
    requestedCashAmount,
    openHelpModal,
    requestedAmount
}: Props) => {
    let description;
    let value;

    if (getCountry() === 'DE' || requestedCashAmount === null) {
        description = messages.fallbackDescription;
        value = requestedAmount;
    } else {
        description = messages.description;
        value = requestedCashAmount;
    }

    return (
        <DashboardCTA
            data-testid="top-up-pending-action"
            title={<FormattedMessage {...messages.title} />}
            className={dashboardCtaStyles.nonBottomDashboardAction}
            icon={<TopupPendingSVG />}
            description={
                <FormattedMessage
                    {...description}
                    values={{
                        amount: (
                            <span className={styles.topupPendingAmount}>
                                <MoneyWithDecimals value={value} />
                            </span>
                        )
                    }}
                />
            }
            cta={
                <Button
                    variant="primary"
                    onClick={openHelpModal}
                    className={styles.dashboardActionCTA}
                >
                    <FormattedMessage {...messages.ctaText} />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(TopUpPending));
